export default "__VITE_ASSET__DtWS3wZ1__"